import React, { useState, useEffect, useRef } from 'react';

import { motion } from "framer-motion";

import consts from "../libs/consts";

import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function SkeletonComponent() {

    return (
        <div 
            className={`${consts.animationFadeIn} skeleton_box`} 
        >
            <Skeleton />
        </div>
    )    
}